export default "__VITE_ASSET__DxY4_Slx__"